import {
  Button,
  CheckboxChangeEvent,
  Empty,
  Flex,
  Grid,
  Modal,
  Statistic,
  Tabs,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomMessage } from "../../components";
import { useLayout } from "../../context/LayoutContext";
import { OrderDetailsType, OrderListResponse } from "../../hooks/Order/data";
import { useGetOrderList, useOrderCancel } from "../../hooks/Order/order.hooks";
import useGetTimezone from "../../hooks/Timezone/timezone.hooks";
import { ContentWrapper } from "../../layouts/components";
import styles from "./styleModule";
import "./styles.scss";

import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { usePay } from "../../hooks/Checkout/checkout.hooks";
import { useGetSkiResort } from "../../hooks/Resorts/resort.hooks";
import { steps } from "../Result/enumerations/steps";
import { RecordItem } from "./compontents";

// Extend with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const Record = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getHeaderHeight } = useLayout();
  const { Countdown } = Statistic;
  const { confirm } = Modal;
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { toServerTimezone, toLocalTimezone, formatDate, forceDate } =
    useGetTimezone();
  const [activeKey, setActiveKey] = useState<string>("0");
  const { mutateAsync: pay } = usePay();
  const [loading, setLoading] = useState<boolean>(false);
  const [openConfirmRefund, setOpenConfirmRefund] = useState<boolean>(false);

  const [selectedItem, setSelecteditem] = useState<
    OrderListResponse | undefined
  >();
  const [selectedRefundItem, setSelectedRefundItem] = useState<
    OrderListResponse | undefined
  >();
  const [selectedOrders, setSelectedOrders] = useState<string[]>([]);

  const tabMappingStatus: Record<string, string> = {
    //全部：0、1、2、3、4、5、6、7、8 待付款：0、1 已付款：2、5 退款處理：4、5、6、7、8 支付異常：3
    "0": "",
    "1": "0,1",
    "2": "2,5",
    "3": "4,5,6,7,8",
    "4": "3",
  };

  const { data, refetch } = useGetOrderList(
    { status: tabMappingStatus[activeKey] },
    {}
  );
  const { data: resortList } = useGetSkiResort({});

  const { mutate: orderCancel } = useOrderCancel();

  const handleChangeTab = (key: string) => {
    setActiveKey(key);
  };

  // const onChange = (val: countdownValueType | undefined) => {
  //   if (typeof val === "number" && 4.95 * 1000 < val && val < 5 * 1000) {
  //     console.log("changed!");
  //   }
  // };

  const handleCancel = (item: OrderListResponse) => {
    confirm({
      title: t("record.cancelOrder"),
      content: t("record.cancelOrder.content"),
      icon: null,
      okButtonProps: { danger: true },
      okText: t("normal.confirm"),
      cancelText: t("normal.cancel"),
      onOk: () => {
        orderCancel(
          { params: { payment_number: item.payment_number } },
          {
            onSuccess: async (data: any) => {
              CustomMessage({ alertMessage: t("normal.submit.success") });
              refetch();
            },
            onError: (error: any) => {
              CustomMessage({
                alertMessage: t([
                  `error.${error.data.result.code}`,
                  error.data.result.message,
                ]),
                alertType: "error",
              });
            },
          }
        );
      },
    });
  };

  const handleRefund = (item: OrderListResponse) => {
    setSelecteditem(item);
  };

  const handleCheckout = async (item: OrderListResponse) => {
    navigate(
      `/search/?step=${steps.PAY}&payment_number=${item.payment_number}`,
      {
        state: { cartItems: item.order_details, total_amount: item.amount },
      }
    );
  };

  const handleProcessRefund = (item: OrderListResponse) => {
    setOpenConfirmRefund(true);
    setSelectedRefundItem(item);
  };

  const handleOpenLine = () => {
    window.open(process.env.REACT_APP_LINE_URL, "_blank");
  };

  const handleConfirmRefund = () => {
    if (!selectedRefundItem) return;
    navigate(
      `/refund/?payment_number=${selectedRefundItem?.payment_number}&amount=${selectedRefundItem?.amount}`
    );
  };

  const cancelRefund = () => {
    setSelectedRefundItem(undefined);
    setOpenConfirmRefund(false);
  };

  const handleClickDetail = (detail: OrderDetailsType) => {
    navigate(`/record/detail/${detail.order_number}`);
  };

  const handleOpenFeedback = (
    e: React.MouseEvent<HTMLButtonElement>,
    detail: OrderDetailsType
  ) => {
    e.stopPropagation();
    navigate(
      `/record/detail/${detail.order_number}?feedback=true&order_token=${detail.order_token}`
    );
  };

  const handleOnSelectOrder = (
    e: CheckboxChangeEvent,
    detail: OrderDetailsType
  ) => {
    if (e.target.checked === true) {
      setSelectedOrders((prev) => [...prev, detail.order_number]);
    } else {
      setSelectedOrders((prevItems) =>
        prevItems.filter((item) => item !== detail.order_number)
      );
    }
  };

  useEffect(() => {
    if (data) console.debug("orderList", data);
  }, [data]);

  return (
    <ContentWrapper>
      <div
        className={`${styles.record} record`}
        style={{ "--marginTop": getHeaderHeight() } as React.CSSProperties}
      >
        <Tabs
          activeKey={activeKey}
          onChange={handleChangeTab}
          items={[
            ...Array.from({ length: 5 }, (_, i) => {
              return {
                label: t(`record.tabs.${i}`),
                key: i.toString(),
              };
            }),
          ]}
          style={{
            top: `calc(${getHeaderHeight()} - 2px)`,
          }}
        />
        <Flex
          vertical
          gap={16}
          // style={{
          //   overflow: "scroll",
          //   height: `calc(100vh - ${getHeaderHeight()} - 63px - ${
          //     screens.sm ? "40px" : "18px"
          //   })`,
          // }}
        >
          {resortList && data && data.length > 0 ? (
            data?.map((item: OrderListResponse, index: number) => (
              <RecordItem
                key={`record_${index}`}
                item={item}
                resortList={resortList}
                selectedItem={selectedItem}
                setSelectedItem={setSelecteditem}
                selectedOrders={selectedOrders}
                setSelectedOrders={setSelectedOrders}
                handleCancel={handleCancel}
                handleCheckout={handleCheckout}
                handleProcessRefund={handleProcessRefund}
                handleRefund={handleRefund}
                handleClickDetail={handleClickDetail}
                handleOpenFeedback={handleOpenFeedback}
                loading={loading}
              />
            ))
          ) : (
            <Empty description={t("normal.empty.description")} />
          )}
        </Flex>
        <Modal
          onCancel={cancelRefund}
          open={openConfirmRefund}
          footer={null}
          width={335}
          centered
        >
          <div className={styles.modalContent}>
            <div>
              <Trans i18nKey={"orderRefund.modal.content"} />
            </div>
            <div className={styles.refundModalActions}>
              <Button type="primary" size="small" onClick={handleConfirmRefund}>
                {t("browser.understand")}
              </Button>
              <Button size="small" onClick={handleOpenLine}>
                {t("orderRefund.modal.line")}
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </ContentWrapper>
  );
};

export default Record;
